import { db } from "./main.js";
import { getDocs, collection, query } from "firebase/firestore";
import { formatPetNameForURL } from "./utilities.js";

const stateList = {
  "Alabama": "AL",
  "Alaska": "AK",
  "Arizona": "AZ",
  "Arkansas": "AR",
  "California": "CA",
  "Colorado": "CO",
  "Connecticut": "CT",
  "Delaware": "DE",
  "Florida": "FL",
  "Georgia": "GA",
  "Hawaii": "HI",
  "Idaho": "ID",
  "Illinois": "IL",
  "Indiana": "IN",
  "Iowa": "IA",
  "Kansas": "KS",
  "Kentucky": "KY",
  "Louisiana": "LA",
  "Maine": "ME",
  "Maryland": "MD",
  "Massachusetts": "MA",
  "Michigan": "MI",
  "Minnesota": "MN",
  "Mississippi": "MS",
  "Missouri": "MO",
  "Montana": "MT",
  "Nebraska": "NE",
  "Nevada": "NV",
  "New Hampshire": "NH",
  "New Jersey": "NJ",
  "New Mexico": "NM",
  "New York": "NY",
  "North Carolina": "NC",
  "North Dakota": "ND",
  "Ohio": "OH",
  "Oklahoma": "OK",
  "Oregon": "OR",
  "Pennsylvania": "PA",
  "Rhode Island": "RI",
  "South Carolina": "SC",
  "South Dakota": "SD",
  "Tennessee": "TN",
  "Texas": "TX",
  "Utah": "UT",
  "Vermont": "VT",
  "Virginia": "VA",
  "Washington": "WA",
  "West Virginia": "WV",
  "Wisconsin": "WI",
  "Wyoming": "WY",
};

if (window.location.pathname === "/missing/") {
  if (document.getElementById("main-pets-container")) {
    displayMainRandomPets();
  }
}

// Call the displayLostPets function when the page is loaded
if (window.location.pathname.startsWith("/missing/lost/")) {
  const pet_type = "lost";
  document.addEventListener("DOMContentLoaded", () => {
    if (document.getElementById("lost-pets-container")) {
      // $("#loading-spinner").show();
      $(".recent-reported").addClass("spinny");
      // displayLostPets(pet_type);
      // displayRandomPets(pet_type);
      displayRandomPetsByType("lost", 6);
      // Add the dropdown fill code here
      const dropdown = document.getElementById("states-dropdown");

      for (const state in stateList) {
        const option = document.createElement("option");
        option.value = `/missing/lost/${stateList[state].toLowerCase()}/`;
        option.textContent = state;
        dropdown.appendChild(option);
      }
    }
    if (document.getElementById("state-pets-container")) {
      displayStateLostPets(st_var, pet_type);
      //displayStateCityLostLinks(st_var, pet_type);
    }
    if (document.getElementById("state-backup-pets-container")) {
      displayBackupPets(st_var, "found");
    }
    if (document.getElementById("city-pets-container")) {
      displayCityLostPets(st_var, city_var, pet_type);
    }
  });
}

if (window.location.pathname.startsWith("/missing/found/")) {
  const pet_type = "found";
  document.addEventListener("DOMContentLoaded", () => {
    if (document.getElementById("found-pets-container")) {
      // $("#loading-spinner").show();
      // displayLostPets(pet_type);
      $(".recent-reported").addClass("spinny");
      displayRandomPetsByType("found", 6);

      const dropdown = document.getElementById("states-dropdown");

      for (const state in stateList) {
        const option = document.createElement("option");
        option.value = `/missing/found/${stateList[state].toLowerCase()}/`;
        option.textContent = state;
        dropdown.appendChild(option);
      }
    }
    if (document.getElementById("state-pets-container")) {
      displayStateLostPets(st_var, pet_type);
    }
    if (document.getElementById("state-backup-pets-container")) {
      displayBackupPets(st_var, "lost");
    }
    if (document.getElementById("city-pets-container")) {
      displayCityLostPets(st_var, city_var, pet_type);
    }
  });
}

// Function to display lost pets for a specific state on the page
async function displayCityLostPets(state, city, pet_type) {
  const cityPetsContainer = document.getElementById("city-pets-container");

  if (!cityPetsContainer) {
    console.error("Cannot find the 'city-pets-container' element in the HTML.");
    return;
  }

  // Get a reference to the "pets" collection for the specified state and city
  const petsRef = collection(
    db,
    `missing/${pet_type}/states/${state}/cities/${city}/pets`
  );

  // Create a container element for the pet divs
  const petContainer = document.createElement("div");
  petContainer.className = "pet-container";

  let hasPets = false;

  // Create a query to select all the documents in the "pets" collection for this city
  const allPetsQuery = query(petsRef);

  // Get all the documents that match the query
  const petsSnapshot = await getDocs(allPetsQuery);

  // Sort the pet documents by plan
  petsSnapshot.docs.sort((a, b) => {
    if (a.data().plan === "premium") {
      return -1;
    } else if (b.data().plan === "premium") {
      return 1;
    } else {
      return 0;
    }
  });

  // Loop through each pet document in this city
  for (const petDoc of petsSnapshot.docs) {
    // Get the data for the pet document
    const petData = petDoc.data();
    if (petData.active) {
      const dateString = petData.missing_date;
      const date = new Date(dateString);
      const formattedDate = date.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
      });

      // Create a div to hold the pet information
      const petDiv = document.createElement("div");
      petDiv.className = "pet";

      if (petData.plan === "premium") {
        petDiv.classList.add("premium-pet");
      }

      // Create an image element to display the pet's image
      const imageElem = document.createElement("img");
      imageElem.className = "pet-image";
      imageElem.alt = petData.name;

      // // Get a reference to the pet's image in Firebase Storage
      // const imageRef = ref(storage, `pets/${petDoc.id}`);

      // // Get the download URL for the pet's image
      // const downloadURL = await getDownloadURL(imageRef);

      const main_image = petData.image_url_one;

      // Set the image source to the download URL
      imageElem.src = main_image;

      // Append the image element to the pet div
      petDiv.appendChild(imageElem);

      // Create a div to hold the pet name, breed, and age
      const petInfoDiv = document.createElement("div");
      petInfoDiv.className = "pet-info";

      // Create elements for the pet name, breed, and age
      const nameElem = document.createElement("h3");
      nameElem.textContent = petData.pet_name;
      petInfoDiv.appendChild(nameElem);

      const cityElem = document.createElement("p");
      cityElem.textContent = `${petData.city}, ${petData.state}`;
      petInfoDiv.appendChild(cityElem);

      const dateElem = document.createElement("p");
      dateElem.textContent = `Missing since ${formattedDate}`;
      petInfoDiv.appendChild(dateElem);

      const dividerElem = document.createElement("hr");
      petInfoDiv.appendChild(dividerElem);

      // const breedElem = document.createElement("p");
      // breedElem.textContent = `Breed: ${petData.breed}`;
      // petInfoDiv.appendChild(breedElem);

      // const ageElem = document.createElement("p");
      // ageElem.textContent = `Age: ${petData.age}`;
      // petInfoDiv.appendChild(ageElem);

      const detailsDivElem = document.createElement("div");
      detailsDivElem.className = "details-button-container";

      const detailsBtnElem = document.createElement("button");
      detailsBtnElem.textContent = `View Details`;

      detailsDivElem.appendChild(detailsBtnElem);

      petInfoDiv.appendChild(detailsDivElem);

      // Add the pet info div to the pet div
      petDiv.appendChild(petInfoDiv);

      const formattedPetName = formatPetNameForURL(petData.pet_name);
      const linkElem = document.createElement("a");
      linkElem.href = `/missing/pet/${petData.uid}/${formattedPetName}/`; // replace with the actual link

      // Append the pet div to the link element
      linkElem.appendChild(petDiv);

      // Add the link element to the container
      petContainer.appendChild(linkElem);

      hasPets = true;
    }
  }
  // Add the container to the statePetsContainer if there are pets
  if (hasPets) {
    cityPetsContainer.appendChild(petContainer);
  } else {
    // cityPetsContainer.textContent = "No pets to display.";

    const noPetsDiv = document.createElement("div");
    noPetsDiv.className = "no-pets-message";
    noPetsDiv.textContent = `No ${pet_type} pets have been reported recently. Please check back later.`;

    // Append the "No pets to display" div to the lostPetsContainer
    cityPetsContainer.appendChild(noPetsDiv);

    $("#loading-spinner").hide();
  }
}

// Function to display lost pets for a specific state on the page
async function displayStateLostPets(state, pet_type) {
  const statePetsContainer = document.getElementById("state-pets-container");
  if (!statePetsContainer) {
    console.error(
      "Cannot find the 'state-pets-container' element in the HTML."
    );
    return;
  }

  const petsRef = collection(db, `missing/${pet_type}/states/${state}/cities`);
  const citiesSnapshot = await getDocs(petsRef);

  const petContainer = document.createElement("div");
  petContainer.className = "pet-container";

  let hasPets = false;
  const premiumPets = [];
  const otherPets = [];

  for (const cityDoc of citiesSnapshot.docs) {
    const cityId = cityDoc.id;

    const cityPetsRef = collection(
      db,
      `missing/${pet_type}/states/${state}/cities/${cityId}/pets`
    );

    const petsSnapshot = await getDocs(cityPetsRef);

    petsSnapshot.forEach((doc) => {
      const petData = doc.data();
      if (petData.active) {
        if (petData.plan === "premium") {
          premiumPets.push(petData);
        } else {
          otherPets.push(petData);
        }
      }
    });
  }

  const sortedPets = premiumPets.concat(otherPets);

  for (const petData of sortedPets) {
    const dateString = petData.missing_date;
    const date = new Date(dateString);
    const formattedDate = date.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });

    const petDiv = document.createElement("div");
    petDiv.className = "pet";

    if (petData.plan === "premium") {
      petDiv.classList.add("premium-pet");
    }

    const imageElem = document.createElement("img");
    imageElem.className = "pet-image";
    imageElem.alt = petData.name;
    const main_image = petData.image_url_one;
    imageElem.src = main_image;
    petDiv.appendChild(imageElem);

    const petTypeDiv = document.createElement("div");
    if (petData.packageType == "lost") {
      petTypeDiv.className = "pet-type-info lost-type-info";
    } else if (petData.packageType == "found") {
      petTypeDiv.className = "pet-type-info found-type-info";
    }

    // Create a new paragraph element for the pet type, and append it
    const typeElem = document.createElement("p");

    if (petData.packageType == "lost") {
      typeElem.textContent = "Lost Pet";
    } else if (petData.packageType == "found") {
      typeElem.textContent = "Found Pet";
    }
    petTypeDiv.appendChild(typeElem);

    petDiv.appendChild(petTypeDiv);

    const petInfoDiv = document.createElement("div");
    petInfoDiv.className = "pet-info";

    const nameElem = document.createElement("h3");
    nameElem.textContent = petData.pet_name;
    petInfoDiv.appendChild(nameElem);

    const cityElem = document.createElement("p");
    cityElem.className = "pet-city";
    cityElem.textContent = `${petData.city}, ${petData.state}`;
    petInfoDiv.appendChild(cityElem);

    const dateElem = document.createElement("p");
    dateElem.className = "pet-date";
    dateElem.textContent = `Missing since ${formattedDate}`;
    petInfoDiv.appendChild(dateElem);

    const dividerElem = document.createElement("hr");
    petInfoDiv.appendChild(dividerElem);

    const detailsDivElem = document.createElement("div");
    detailsDivElem.className = "details-button-container";

    const detailsBtnElem = document.createElement("button");
    detailsBtnElem.textContent = `View Details`;

    detailsDivElem.appendChild(detailsBtnElem);

    petInfoDiv.appendChild(detailsDivElem);

    petDiv.appendChild(petInfoDiv);
    const formattedPetName = formatPetNameForURL(petData.pet_name);
    const linkElem = document.createElement("a");
    linkElem.href = `/missing/pet/${petData.uid}/${formattedPetName}/`; // replace with the actual link
    linkElem.appendChild(petDiv);
    petContainer.appendChild(linkElem);

    hasPets = true;
  }

  if (hasPets) {
    statePetsContainer.appendChild(petContainer);
  } else {
    // Create a div for the "No pets to display" message
    const noPetsDiv = document.createElement("div");
    noPetsDiv.className = "no-pets-message";
    noPetsDiv.textContent = `No ${pet_type} pets have been reported recently. Please check back later.`;

    // Append the "No pets to display" div to the lostPetsContainer
    statePetsContainer.appendChild(noPetsDiv);
  }
}

// Function to display lost pets for a specific state on the page
async function displayBackupPets(state, pet_type) {
  const statePetsContainer = document.getElementById(
    "state-backup-pets-container"
  );
  if (!statePetsContainer) {
    console.error(
      "Cannot find the 'state-backup-pets-container' element in the HTML."
    );
    return;
  }

  // Create and append an H3 tag at the top of the function
  const h3Element = document.createElement("h3");
  h3Element.textContent = `Recently reported ${pet_type} pets`; // Change this text to whatever you want
  statePetsContainer.appendChild(h3Element);

  const petsRef = collection(db, `missing/${pet_type}/states/${state}/cities`);
  const citiesSnapshot = await getDocs(petsRef);

  const petContainer = document.createElement("div");
  petContainer.className = "pet-container";

  let hasPets = false;
  const premiumPets = [];
  const otherPets = [];

  for (const cityDoc of citiesSnapshot.docs) {
    const cityId = cityDoc.id;

    const cityPetsRef = collection(
      db,
      `missing/${pet_type}/states/${state}/cities/${cityId}/pets`
    );

    const petsSnapshot = await getDocs(cityPetsRef);

    petsSnapshot.forEach((doc) => {
      const petData = doc.data();
      if (petData.active) {
        if (petData.plan === "premium") {
          premiumPets.push(petData);
        } else {
          otherPets.push(petData);
        }
      }
    });
  }

  const sortedPets = premiumPets.concat(otherPets);

  for (const petData of sortedPets) {
    const dateString = petData.missing_date;
    const date = new Date(dateString);
    const formattedDate = date.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });

    const petDiv = document.createElement("div");
    petDiv.className = "pet";

    if (petData.plan === "premium") {
      petDiv.classList.add("premium-pet");
    }

    const imageElem = document.createElement("img");
    imageElem.className = "pet-image";
    imageElem.alt = petData.name;
    const main_image = petData.image_url_one;
    imageElem.src = main_image;
    petDiv.appendChild(imageElem);

    const petTypeDiv = document.createElement("div");
    if (petData.packageType == "lost") {
      petTypeDiv.className = "pet-type-info lost-type-info";
    } else if (petData.packageType == "found") {
      petTypeDiv.className = "pet-type-info found-type-info";
    }

    // Create a new paragraph element for the pet type, and append it
    const typeElem = document.createElement("p");

    if (petData.packageType == "lost") {
      typeElem.textContent = "Lost Pet";
    } else if (petData.packageType == "found") {
      typeElem.textContent = "Found Pet";
    }
    petTypeDiv.appendChild(typeElem);

    petDiv.appendChild(petTypeDiv);

    const petInfoDiv = document.createElement("div");
    petInfoDiv.className = "pet-info";

    const nameElem = document.createElement("h3");
    nameElem.textContent = petData.pet_name;
    petInfoDiv.appendChild(nameElem);

    const cityElem = document.createElement("p");
    cityElem.className = "pet-city";
    cityElem.textContent = `${petData.city}, ${petData.state}`;
    petInfoDiv.appendChild(cityElem);

    const dateElem = document.createElement("p");
    dateElem.className = "pet-date";
    dateElem.textContent = `Missing since ${formattedDate}`;
    petInfoDiv.appendChild(dateElem);

    const dividerElem = document.createElement("hr");
    petInfoDiv.appendChild(dividerElem);

    const detailsDivElem = document.createElement("div");
    detailsDivElem.className = "details-button-container";

    const detailsBtnElem = document.createElement("button");
    detailsBtnElem.textContent = `View Details`;

    detailsDivElem.appendChild(detailsBtnElem);

    petInfoDiv.appendChild(detailsDivElem);

    petDiv.appendChild(petInfoDiv);
    const formattedPetName = formatPetNameForURL(petData.pet_name);
    const linkElem = document.createElement("a");
    linkElem.href = `/missing/pet/${petData.uid}/${formattedPetName}/`; // replace with the actual link
    linkElem.appendChild(petDiv);
    petContainer.appendChild(linkElem);

    hasPets = true;
  }

  if (hasPets) {
    statePetsContainer.appendChild(petContainer);
  }
}

// Function to display lost pets city links for a specific state on the page
async function displayStateCityLostLinks(state, pet_type) {
  const citiesLinkRef = collection(
    db,
    `missing/${pet_type}/states/${state}/cities`
  );
  const citiesLinkSnapshot = await getDocs(citiesLinkRef);
  const citiesLinks = citiesLinkSnapshot.docs.map((doc) => doc.id); // doc.id is the city name
  // here you have all city names in the cities array, you can now render them as you wish
  renderCities(citiesLinks, pet_type, state);
}

function renderCities(cities, pet_type, stateId) {
  const columnsCount = 3;
  const columns = [];
  for (let i = 0; i < columnsCount; i++) {
    const column = document.createElement("div");
    column.className = "column";
    columns.push(column);
  }

  // Sort cities alphabetically
  cities.sort();

  // Distribute cities evenly into each column
  const citiesPerColumn = Math.ceil(cities.length / columnsCount);
  for (let i = 0; i < cities.length; i++) {
    const cityDiv = document.createElement("div");
    const cityLink = document.createElement("a");

    let cityIdUrl = cities[i];
    cityIdUrl = cityIdUrl.toLowerCase().replace(/\s+/g, "-");

    cityLink.href = `/missing/${pet_type}/${cityIdUrl}-${stateList[
      stateId
    ].toLowerCase()}/`;

    cityLink.textContent = cities[i];

    cityDiv.appendChild(cityLink);

    // Compute the appropriate column for the current city
    const column = columns[Math.floor(i / citiesPerColumn)];
    column.appendChild(cityDiv);
  }

  const container = document.getElementById("state-lks-container");
  const columnsContainer = container.querySelector(".columns");
  columns.forEach((column) => columnsContainer.appendChild(column));
}

// Function to display lost pets on the page
async function displayLostPets(pet_type) {
  const lostPetsContainer = document.getElementById("lost-pets-container");
  if (!lostPetsContainer) {
    console.error("Cannot find the 'lost-pets-container' element in the HTML.");
    return;
  }

  // Get a reference to the Lost collection
  const lostRef = collection(db, `missing/${pet_type}/states`);

  // Get all the documents in the Lost collection
  const lostSnapshot = await getDocs(lostRef);

  // Get a reference to the columns container
  const columnsContainer = document.querySelector(".columns");

  let index = 0;

  // Loop through each state document
  // lostSnapshot.forEach(async (stateDoc) => {
  for (const stateDoc of lostSnapshot.docs) {
    const stateId = stateDoc.id;
    // Skip the "default" state
    if (stateId === "default") {
      $("#loading-spinner").hide();
      continue;
    }

    const stateAbbreviations = {
      "Alabama": "AL",
      "Alaska": "AK",
      "Arizona": "AZ",
      "Arkansas": "AR",
      "California": "CA",
      "Colorado": "CO",
      "Connecticut": "CT",
      "Delaware": "DE",
      "Florida": "FL",
      "Georgia": "GA",
      "Hawaii": "HI",
      "Idaho": "ID",
      "Illinois": "IL",
      "Indiana": "IN",
      "Iowa": "IA",
      "Kansas": "KS",
      "Kentucky": "KY",
      "Louisiana": "LA",
      "Maine": "ME",
      "Maryland": "MD",
      "Massachusetts": "MA",
      "Michigan": "MI",
      "Minnesota": "MN",
      "Mississippi": "MS",
      "Missouri": "MO",
      "Montana": "MT",
      "Nebraska": "NE",
      "Nevada": "NV",
      "New Hampshire": "NH",
      "New Jersey": "NJ",
      "New Mexico": "NM",
      "New York": "NY",
      "North Carolina": "NC",
      "North Dakota": "ND",
      "Ohio": "OH",
      "Oklahoma": "OK",
      "Oregon": "OR",
      "Pennsylvania": "PA",
      "Rhode Island": "RI",
      "South Carolina": "SC",
      "South Dakota": "SD",
      "Tennessee": "TN",
      "Texas": "TX",
      "Utah": "UT",
      "Vermont": "VT",
      "Virginia": "VA",
      "Washington": "WA",
      "West Virginia": "WV",
      "Wisconsin": "WI",
      "Wyoming": "WY",
    };

    // Create a div to hold the state name
    const stateDiv = document.createElement("div");
    stateDiv.className = "state";

    // Create a div to hold the cities
    const citiesDiv = document.createElement("div");
    citiesDiv.className = "cities";

    // Get a reference to the cities collection for this state
    const citiesRef = collection(
      db,
      `missing/${pet_type}/states`,
      stateId,
      "cities"
    );

    // Get all the documents in the cities collection for this state
    const citiesSnapshot = await getDocs(citiesRef);

    let hasActivePets = false;

    // Loop through each city document
    // citiesSnapshot.forEach(async (cityDoc) => {
    for (const cityDoc of citiesSnapshot.docs) {
      const cityId = cityDoc.id;

      // Create a div to hold the city name and pet count
      const cityDiv = document.createElement("div");
      cityDiv.className = "city";

      // Get all the documents in the pets collection for this city
      const petsRef = collection(
        db,
        `missing/${pet_type}/states`,
        stateId,
        "cities",
        cityId,
        "pets"
      );
      const petsSnapshot = await getDocs(petsRef);
      let totalPets = 0;

      // Loop through each pet document in this city
      // petsSnapshot.forEach((petDoc) => {
      //   // Get the data for the pet document
      //   const petData = petDoc.data();

      //   // Check if the pet's status is 'active'
      //   if (petData.status === "active") {
      //     totalPets++;
      //     hasActivePets = true;
      //   }
      // });

      for (const petDoc of petsSnapshot.docs) {
        // Get the data for the pet document
        const petData = petDoc.data();

        // Check if the pet's status is 'active'
        if (petData.active) {
          totalPets++;
          hasActivePets = true;
        }
      }

      // Check if there are active pets in the city
      if (totalPets > 0) {
        // Create a link for the city
        const cityLink = document.createElement("a");
        const cityIdUrl = cityDoc.id.replace(/\s+/g, "-");
        cityLink.href = `/missing/${pet_type}/${cityIdUrl.toLowerCase()}-${stateAbbreviations[
          stateId
        ].toLowerCase()}/`;

        // Set the city name as the text content of the link
        cityLink.textContent = `${cityId}`;

        // Append the link to the city div
        cityDiv.appendChild(cityLink);

        // Add the number of pets to the city div
        const petCount = document.createElement("span");
        petCount.textContent = ` (${totalPets})`;
        cityDiv.appendChild(petCount);

        // Add the city div to the cities div
        citiesDiv.appendChild(cityDiv);
      }
    }

    // Check if there are active pets in the state

    // Create a link for the state
    const stateLink = document.createElement("a");
    stateLink.href = `/missing/${pet_type}/${stateAbbreviations[
      stateId
    ].toLowerCase()}/`;

    // Set the state name as the text content of the link
    stateLink.textContent = stateId;

    // Append the link to the state div
    stateDiv.appendChild(stateLink);

    // Add the state div and cities div to the lostPetsContainer
    // lostPetsContainer.appendChild(stateDiv);
    // lostPetsContainer.appendChild(citiesDiv);

    // Append the state div to one of the columns
    const column = columnsContainer.children[index % 2];
    column.appendChild(stateDiv);
    column.appendChild(citiesDiv);
    index++;

    $("#loading-spinner").hide();
  }
}

// Function to display random pets on the page based on the specified petType
async function displayRandomPetsByType(petType, numberOfPetsToShow) {
  const randomPetsContainer = document.getElementById("random-pets-container");
  if (!randomPetsContainer) {
    console.error("Cannot find the 'random-pets' element in the HTML.");
    return;
  }

  const petContainer = document.createElement("div");
  petContainer.className = "pet-container";
  let shownPetCount = 0;

  const petsData = await getRandomPets(petType, numberOfPetsToShow);

  for (const petData of petsData) {
    if (petData.active) {
      const dateString = petData.missing_date;
      const date = new Date(dateString);
      const formattedDate = date.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
      });

      const petDiv = document.createElement("div");
      petDiv.className = "pet";

      if (petData.plan === "premium") {
        petDiv.classList.add("premium-pet");
      }
      const stateAbv = stateList[petData.state];
      const imageElem = document.createElement("img");
      imageElem.className = "pet-image";
      imageElem.alt = petData.name;
      const main_image = petData.image_url_one;
      imageElem.src = main_image;
      petDiv.appendChild(imageElem);

      const petTypeDiv = document.createElement("div");
      if (petData.pet_type == "lost") {
        petTypeDiv.className = "pet-type-info lost-type-info";
      } else if (petData.pet_type == "found") {
        petTypeDiv.className = "pet-type-info found-type-info";
      }

      // Create a new paragraph element for the pet type, and append it
      const typeElem = document.createElement("p");

      if (petData.pet_type == "lost") {
        typeElem.textContent = "Lost Pet";
      } else if (petData.pet_type == "found") {
        typeElem.textContent = "Found Pet";
      }
      petTypeDiv.appendChild(typeElem);

      petDiv.appendChild(petTypeDiv);

      const petInfoDiv = document.createElement("div");
      petInfoDiv.className = "pet-info";

      const nameElem = document.createElement("h3");
      nameElem.textContent = petData.pet_name;
      petInfoDiv.appendChild(nameElem);

      const cityElem = document.createElement("p");
      cityElem.className = "pet-city";
      cityElem.textContent = `${petData.city}, ${stateAbv}`;
      petInfoDiv.appendChild(cityElem);

      const dateElem = document.createElement("p");
      dateElem.className = "pet-date";
      dateElem.textContent = `Missing since ${formattedDate}`;
      petInfoDiv.appendChild(dateElem);

      const dividerElem = document.createElement("hr");
      petInfoDiv.appendChild(dividerElem);

      const detailsDivElem = document.createElement("div");
      detailsDivElem.className = "details-button-container";

      const detailsBtnElem = document.createElement("button");
      detailsBtnElem.textContent = `View Details`;

      detailsDivElem.appendChild(detailsBtnElem);

      petInfoDiv.appendChild(detailsDivElem);

      petDiv.appendChild(petInfoDiv);
      const formattedPetName = formatPetNameForURL(petData.pet_name);
      const linkElem = document.createElement("a");
      linkElem.href = `/missing/pet/${petData.uid}/${formattedPetName}/`; // replace with the actual link
      linkElem.appendChild(petDiv);
      petContainer.appendChild(linkElem);

      shownPetCount++;
    }

    if (shownPetCount >= numberOfPetsToShow) {
      break; // Stop processing once the required number of pets are shown
    }
  }

  if (shownPetCount > 0) {
    randomPetsContainer.appendChild(petContainer);
  } else {
    randomPetsContainer.textContent = "No pets to display.";
  }

  // $("#loading-spinner").hide();
  $(".recent-reported").removeClass("spinny");
}

// Function to display random pets on the page
async function displayRandomPets(pet_type) {
  const randomPetsContainer = document.getElementById("random-pets");
  if (!randomPetsContainer) {
    console.error("Cannot find the 'random-pets' element in the HTML.");
    return;
  }

  // Get a reference to the random pets collection
  const randomPetsRef = collection(db, `${pet_type}`);

  // Get all the documents in the random pets collection
  const randomPetsSnapshot = await getDocs(randomPetsRef);

  // Take a random selection of 3 pets
  const randomPets = randomPetsSnapshot.docs
    .sort(() => 0.5 - Math.random())
    .slice(0, 3);

  const premiumPets = [];
  const otherPets = [];

  for (const petDoc of randomPets) {
    const petData = petDoc.data();

    if (petData.active) {
      if (petData.plan === "premium") {
        premiumPets.push(petData);
      } else {
        otherPets.push(petData);
      }
    }
  }

  const sortedPets = premiumPets.concat(otherPets).slice(0, 3);

  const petContainer = document.createElement("div");
  petContainer.className = "pet-container";

  let hasPets = false;

  for (const petData of sortedPets) {
    if (petData.active) {
      const dateString = petData.missing_date;
      const date = new Date(dateString);
      const formattedDate = date.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
      });

      const petDiv = document.createElement("div");
      petDiv.className = "pet";

      if (petData.plan === "premium") {
        petDiv.classList.add("premium-pet");
      }

      const imageElem = document.createElement("img");
      imageElem.className = "pet-image";
      imageElem.alt = petData.name;
      const main_image = petData.image_url_one;
      imageElem.src = main_image;
      petDiv.appendChild(imageElem);

      const petInfoDiv = document.createElement("div");
      petInfoDiv.className = "pet-info";

      const nameElem = document.createElement("h3");
      nameElem.textContent = petData.pet_name;
      petInfoDiv.appendChild(nameElem);

      const cityElem = document.createElement("p");
      cityElem.textContent = `${petData.city}, ${petData.state}`;
      petInfoDiv.appendChild(cityElem);

      const dateElem = document.createElement("p");
      dateElem.textContent = `Missing since ${formattedDate}`;
      petInfoDiv.appendChild(dateElem);

      const dividerElem = document.createElement("hr");
      petInfoDiv.appendChild(dividerElem);

      const detailsDivElem = document.createElement("div");
      detailsDivElem.className = "details-button-container";

      const detailsBtnElem = document.createElement("button");
      detailsBtnElem.textContent = `View Details`;

      detailsDivElem.appendChild(detailsBtnElem);

      petInfoDiv.appendChild(detailsDivElem);

      petDiv.appendChild(petInfoDiv);
      const formattedPetName = formatPetNameForURL(petData.pet_name);
      const linkElem = document.createElement("a");
      linkElem.href = `/missing/pet/${petData.uid}/${formattedPetName}/`; // replace with the actual link
      linkElem.appendChild(petDiv);
      petContainer.appendChild(linkElem);

      hasPets = true;
    }
  }

  if (hasPets) {
    randomPetsContainer.appendChild(petContainer);
  } else {
    randomPetsContainer.textContent = "No pets to display.";
  }

  $("#loading-spinner").hide();
}

// Function to display random pets on the page
async function displayMainRandomPets() {
  const randomPetsContainer = document.getElementById("main-pets-container");
  if (!randomPetsContainer) {
    console.error("Cannot find the 'random-pets' element in the HTML.");
    return;
  }

  // Pet types
  const petTypes = ["lost", "found"];
  const numberOfPetsToShow = 3; // Change this number to adjust the number of pets to show

  const petContainer = document.createElement("div");
  petContainer.className = "pet-container";
  let shownPetCount = 0;

  // Array to hold all promises
  let promises = [];

  for (const petType of petTypes) {
    promises.push(getRandomPets(petType, numberOfPetsToShow));
  }

  // Wait for all promises to resolve
  const petsArrays = await Promise.all(promises);
  const pets = [].concat(...petsArrays); // Flatten the array of arrays

  for (const petData of pets) {
    if (petData.active) {
      const dateString = petData.missing_date;
      const date = new Date(dateString);
      const formattedDate = date.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
      });

      const petDiv = document.createElement("div");
      petDiv.className = "pet";

      if (petData.plan === "premium") {
        petDiv.classList.add("premium-pet");
      }
      const stateAbv = stateList[petData.state];
      const imageElem = document.createElement("img");
      imageElem.className = "pet-image";
      imageElem.alt = petData.name;
      const main_image = petData.image_url_one;
      imageElem.src = main_image;
      petDiv.appendChild(imageElem);

      const petTypeDiv = document.createElement("div");
      if (petData.pet_type == "lost") {
        petTypeDiv.className = "pet-type-info lost-type-info";
      } else if (petData.pet_type == "found") {
        petTypeDiv.className = "pet-type-info found-type-info";
      }

      // Create a new paragraph element for the pet type, and append it
      const typeElem = document.createElement("p");

      if (petData.pet_type == "lost") {
        typeElem.textContent = "Lost Pet";
      } else if (petData.pet_type == "found") {
        typeElem.textContent = "Found Pet";
      }
      petTypeDiv.appendChild(typeElem);

      petDiv.appendChild(petTypeDiv);

      const petInfoDiv = document.createElement("div");
      petInfoDiv.className = "pet-info";

      const nameElem = document.createElement("h3");
      nameElem.textContent = petData.pet_name;
      petInfoDiv.appendChild(nameElem);

      const cityElem = document.createElement("p");
      cityElem.className = "pet-city";
      cityElem.textContent = `${petData.city}, ${stateAbv}`;
      petInfoDiv.appendChild(cityElem);

      const dateElem = document.createElement("p");
      dateElem.className = "pet-date";
      dateElem.textContent = `Missing since ${formattedDate}`;
      petInfoDiv.appendChild(dateElem);

      const dividerElem = document.createElement("hr");
      petInfoDiv.appendChild(dividerElem);

      const detailsDivElem = document.createElement("div");
      detailsDivElem.className = "details-button-container";

      const detailsBtnElem = document.createElement("button");
      detailsBtnElem.textContent = `View Details`;

      detailsDivElem.appendChild(detailsBtnElem);

      petInfoDiv.appendChild(detailsDivElem);

      petDiv.appendChild(petInfoDiv);
      const formattedPetName = formatPetNameForURL(petData.pet_name);
      const linkElem = document.createElement("a");
      linkElem.href = `/missing/pet/${petData.uid}/${formattedPetName}/`; // replace with the actual link
      linkElem.appendChild(petDiv);
      petContainer.appendChild(linkElem);

      shownPetCount++;
    }

    if (shownPetCount >= numberOfPetsToShow) {
      break; // Stop processing once the required number of pets are shown
    }
  }

  if (shownPetCount > 0) {
    randomPetsContainer.appendChild(petContainer);
  } else {
    randomPetsContainer.textContent = "No pets to display.";
  }
}

async function getRandomPets(petType, numberOfPets) {
  const randomPetsRef = collection(db, `${petType}`);
  const randomPetsSnapshot = await getDocs(randomPetsRef);
  const randomPets = randomPetsSnapshot.docs
    .sort(() => 0.5 - Math.random())
    .slice(0, numberOfPets);
  const petsData = randomPets.map((pet) => {
    const petData = pet.data();
    petData.pet_type = petType; // We add the pet type to the pet data
    return petData;
  });
  return petsData;
}
